import HomeMain from "@components/HomeMain";
import { Mask } from "antd-mobile";
import { FC } from "react";
import { checkTestHost } from "@/utils";
import { getPrivacyPolicyUrl } from "@/utils/copyright";
import useTranslate from "@/hooks/useTranslate";
import { getMainDomain } from "@/utils/getMainDomain";
import { miQsWeatherDomains } from "@/constants/domain.config";
import { isLongText } from "@/utils/isLongText";
import { getCurrentAdScenario } from "@/hooks/useAdScenario";

const HomeMask: FC = () => {
  const [visible, setVisible] = useState(false);
  useEffect(() => {
    const userAction = LocalStorage.getItem("userAction");
    if (userAction === "accept") {
      setVisible(false);
    } else {
      setVisible(true);
    }
  }, []);
  function handleClick(action: string) {
    return () => {
      if (action === "accept") {
        LocalStorage.setItem("userAction", "accept");
      }
      setVisible(false);
    };
  }
  const { $t } = useTranslate();

  return (
    <>
      <Mask getContainer={document.body} visible={visible}>
        <div className="absolute bottom-12 left-50% translate-x-[-50%] w-310 h-182 bg-[var(--app-bg-64)] rounded-21 flex flex-col items-center gap-y-20">
          <div
            className="text-ellipsis-5  p-[20px_14px_0] font-400 text-14 color-[var(--app-text-12)] lh-19"
            style={{
              wordBreak: isLongText() ? "normal" : "break-all",
            }}
          >
            {getMainDomain() === "24hweather.com" ? $t("title51") : $t("title45")}
            <a className="underline color-[var(--app-text-13)]" href={getPrivacyPolicyUrl()}>
              {$t("title46")}
            </a>
            {$t("title47")}
          </div>
          <div
            className="bg-[var(--app-bg-07)] w-123 h-34 lh-34 center rounded-20 text-center font-500 text-14 color-[var(--app-text-04)]"
            onClick={handleClick("accept")}
          >
            {$t("title44")}
          </div>
        </div>
      </Mask>
    </>
  );
};

const Home: React.FC = () => {
  const { subdomain, domain } = useSubdomain();
  const { hostName } = useHostName();
  const { isTranTabAdScenario } = getCurrentAdScenario();

  const shouldShowHomeMask1 = () => {
    const mainDomain = getMainDomain();

    // 检查域名类型
    if (mainDomain === "24hweather.com") return false;

    // 检查特殊域名列表
    const specialDomains = [
      ...domainMap.mils,
      ...domainMap["v-ls"],
      ...domainMap["mxwg"],
      ...domainMap["miwg"],
      ...domainMap["wg"],
      ...wgDomains3,
    ];
    if (specialDomains.includes(hostName)) return false;

    if (miQsWeatherDomains.includes(hostName)) return false;

    // 检查测试主机
    if (checkTestHost([...domainLinks])) return false;

    // 检查子域名和主域名条件
    if (!subdomain) return false;
    if (mainDomain === "mobi321.com") return false;

    // 检查特定域名
    if (!domain || domain === "wx.mobi321.com") return false;

    return true;
  };

  const shouldShowHomeMask2 = () => {
    // 提前计算可能重复使用的值
    const mainDomain = getMainDomain();
    const isTestHost = checkTestHost([...domainLinks]);

    // 检查特殊域名列表
    const specialDomains = [
      ...domainMap.mils,
      ...domainMap["v-ls"],
      ...domainMap["mxwg"],
      ...domainMap["miwg"],
      ...domainMap["wg"],
      ...wgDomains3,
    ];

    if (specialDomains.includes(hostName)) return false;

    if (miQsWeatherDomains.includes(hostName)) return false;

    // 按条件优先级逐步检查
    if (!isTestHost) return false;
    if (!subdomain || subdomain === "www") return false;
    if (mainDomain === "mobi321.com") return false;
    if (!domain || domain === "wx.mobi321.com") return false;

    return true;
  };
  return (
    <Container>
      <HomeMain />
      {isTranTabAdScenario ? null : (
        <>
          {shouldShowHomeMask1() && <HomeMask />}
          {shouldShowHomeMask2() && <HomeMask />}
        </>
      )}
    </Container>
  );
};
export default Home;
